export default {"src":"/_next/static/media/integration-of-dark-web-monitoring.5c8c49bd.svg","height":286,"width":358,"blurWidth":0,"blurHeight":0};